var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.797,
    height: 21.797,
    viewBox: "0 0 21.797 21.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.27,3.27A9.894,9.894,0,0,1,10.9,0a9.894,9.894,0,0,1,7.629,3.27A9.894,9.894,0,0,1,21.8,10.9a9.894,9.894,0,0,1-3.27,7.629A9.894,9.894,0,0,1,10.9,21.8a9.894,9.894,0,0,1-7.629-3.27A10.877,10.877,0,0,1,0,10.9,9.894,9.894,0,0,1,3.27,3.27Zm9.082,16.348a4.463,4.463,0,0,0,2.725-1.635,7.934,7.934,0,0,0,1.271-3.814,3.008,3.008,0,0,0-.908-2.18,3.2,3.2,0,0,0-2.361-1.09H11.262a5.3,5.3,0,0,1-1.635-.363,1.649,1.649,0,0,1-.545-1.271.944.944,0,0,1,.363-.727,1.377,1.377,0,0,1,.727-.363,1.24,1.24,0,0,1,.908.545c.363.182.545.363.727.363a1.092,1.092,0,0,0,.727-.182,1.092,1.092,0,0,0,.182-.727,2.891,2.891,0,0,0-.908-1.816,7.513,7.513,0,0,0,.908-3.451.391.391,0,0,0-.363-.363A5.615,5.615,0,0,0,10.9,2.18,9.086,9.086,0,0,0,6.176,3.633,4.573,4.573,0,0,0,4.541,7.266a4.651,4.651,0,0,0,1.453,3.451A4.963,4.963,0,0,0,9.445,12.17h0V12.9a2.332,2.332,0,0,0,.727,1.816,2.645,2.645,0,0,0,1.635,1.09v3.27c0,.182,0,.182.182.363S12.17,19.617,12.352,19.617Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.0cbe53d425c530b2fce388f5d3c47d68.svg";
export { ForwardRef as ReactComponent };